import React, { useState, useEffect, useRef } from "react";
import { BiExpand, BiArrowBack } from "react-icons/bi";
import { FiX } from "react-icons/fi";
import {
  BsVolumeUp,
  BsMic,
  BsCameraVideo,
  BsRepeat,
  BsCameraVideoOff,
  BsMicMute,
  BsVolumeMute,
} from "react-icons/bs";
import { CallContainer, CallNav, ProfileContainer, CallOptions } from "./style";
interface DraggableComponentProps {
  handleEndCall: () => void;
}
const DraggableComponent = ({ handleEndCall }: DraggableComponentProps) => {
  const [isDragging, setIsDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [position, setPosition] = useState({
    top: window.innerHeight / 2 - 200,
    left: window.innerWidth / 2 - 120,
  });
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isVolume, setIsVolume] = useState(false);
  const [isMic, setIsMic] = useState(false);
  const [isCamera, setIsCamera] = useState(false);
  const [isSwitch, setIsSwitch] = useState(false);
  const draggableRef = useRef<HTMLDivElement>(null);

  const handleVolume = () => {
    setIsVolume(!isVolume);
  };
  const handleMic = () => {
    setIsMic(!isMic);
  };
  const handleCamera = () => {
    setIsCamera(!isCamera);
  };
  const handleSwitch = () => {
    setIsSwitch(!isSwitch);
  };

  const handleMouseDown = (e: React.MouseEvent) => {
    if (window.innerWidth <= 768 || isFullScreen) {
      return;
    }
    setIsDragging(true);
    const { clientX, clientY } = e;
    const rect = draggableRef.current!.getBoundingClientRect();
    const offsetX = clientX - rect.left;
    const offsetY = clientY - rect.top;
    setOffset({ x: offsetX, y: offsetY });
  };

  useEffect(() => {
    if (isDragging) {
      draggableRef.current!.setPointerCapture(0);
    } else {
      draggableRef.current!.releasePointerCapture(0);
    }
  }, [isDragging]);

  const handleMouseMove = (e: MouseEvent) => {
    if (isDragging) {
      const newLeft = e.clientX - offset.x;
      const newTop = e.clientY - offset.y;

      const rect = draggableRef.current!.getBoundingClientRect();
      const minX = 0;
      const minY = 0;
      const maxX = window.innerWidth - rect.width;
      const maxY = window.innerHeight - rect.height;

      const limitedLeft = Math.min(Math.max(newLeft, minX), maxX);
      const limitedTop = Math.min(Math.max(newTop, minY), maxY);

      setPosition({ left: limitedLeft, top: limitedTop });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };

  useEffect(() => {
    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }
  }, [isDragging]);

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const isSmallScreen = window.innerWidth <= 768;

  const centralizePosition =
    isFullScreen && !isSmallScreen
      ? { top: "50%", left: "50%", transform: "translate(-50%, -50%)" }
      : { top: position.top, left: position.left };

  const style: React.CSSProperties = {
    position: "absolute",
    zIndex: 9999,
    cursor: isFullScreen ? "default" : "move",
    padding: "10px",
    transition: "transform 0.2s ease",
    background: "#f7f7f7",
    color: "#000000",
    width: isFullScreen ? "100%" : "25vw",
    height: isFullScreen ? "100vh" : "50vh",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: isFullScreen ? "none" : "2px 4px 10px 7px #00000054",
    ...centralizePosition,
    ...(isSmallScreen && {
      borderRadius: "0",
      position: isFullScreen ? "absolute" : "relative",
      background: isFullScreen ? "white" : "red",
      width: "auto",
      height: isFullScreen ? "100vh" : "20px",
      top: 0,
      left: 0,
      right: 0,
      cursor: "default",
      padding: "2px 10px",
      color: isFullScreen ? "#000" : "#fff",
      fontSize: "12px",
    }),
  };

  return (
    <>
      <div
        ref={draggableRef}
        style={style}
        onMouseDown={handleMouseDown}
        className={isSmallScreen ? "disabled-drag" : ""}
      >
        <CallNav
          style={{
            borderBottom: isSmallScreen ? "none" : "",
            flexDirection: isFullScreen ? "row-reverse" : "initial",
            paddingTop: isSmallScreen || !isFullScreen ? "0" : "0",
            marginTop: isFullScreen ? "10px" : "0",
          }}
        >
          <span>Audio call</span>
          <button
            onClick={toggleFullScreen}
            style={{ color: isSmallScreen || !isFullScreen ? "#000" : "" }}
          >
            {isFullScreen ? (
              <BiArrowBack color="#000" size={22} />
            ) : (
              <>
                {!isSmallScreen ? (
                  <BiExpand color="#000" size={22} />
                ) : (
                  <div
                    style={{ display: "flex", fontSize: "10px", gap: "10px" }}
                  >
                    <span style={{ fontSize: "10px", color: "#000" }}>
                      Expand call
                    </span>
                    <BiExpand color="#000" />
                  </div>
                )}
              </>
            )}
          </button>
        </CallNav>
        {!isSmallScreen || isFullScreen ? (
          <CallContainer>
            <ProfileContainer>
              <div>
                <img src="image/user101.png" />
                <span>samuel meshach</span>
                <span>00 : 00</span>
              </div>
            </ProfileContainer>
            <CallOptions>
              <div onClick={handleEndCall}>
                <span>
                  <FiX />
                </span>
              </div>
              <div>
                <span
                  onClick={handleVolume}
                  style={{ backgroundColor: isVolume ? "#000" : "" }}
                >
                  {isVolume ? (
                    <BsVolumeMute title="Volume" />
                  ) : (
                    <BsVolumeUp title="Mute volume" />
                  )}
                </span>
                <span
                  onClick={handleMic}
                  style={{ backgroundColor: isMic ? "#000" : "" }}
                >
                  {isMic ? (
                    <BsMicMute title="Mic" />
                  ) : (
                    <BsMic title="Mute Mic" />
                  )}
                </span>
                <span
                  onClick={handleCamera}
                  style={{ backgroundColor: !isCamera ? "#000" : "" }}
                >
                  {isCamera ? (
                    <BsCameraVideo title="Turn off Camera" />
                  ) : (
                    <BsCameraVideoOff title="Turn on Camera" />
                  )}
                </span>
                {isCamera ? (
                  <span
                    onClick={handleSwitch}
                    style={{ backgroundColor: isSwitch ? "#000" : "" }}
                  >
                    <BsRepeat title="Switch Camera" />
                  </span>
                ) : (
                  <span style={{ backgroundColor: "#c6c4c4" }}>
                    <BsRepeat title="Switch Camera" />
                  </span>
                )}
              </div>
            </CallOptions>
          </CallContainer>
        ) : null}
      </div>
    </>
  );
};

export default DraggableComponent;
